import { render, staticRenderFns } from "./MonthlyEPFExport.vue?vue&type=template&id=6ed9bfa0"
import script from "./MonthlyEPFExport.vue?vue&type=script&lang=js"
export * from "./MonthlyEPFExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports